export default "__VITE_ASSET__CbTISrUz__"